<template>
	<main class="single page main" :key="currentPageID" :class="'type-' + currentPostType">
		<template v-if="!isProtected">
			<PageHeader />
			<ModuleBuilder />
		</template>
		<PasswordProtection v-else />
	</main>
</template>

<script>
import ModuleBuilder from '@/components/ModuleBuilder'
import SocialShareArticle from '@/components/elements/SocialShareArticle'
import PasswordProtection from '@/components/parts/PasswordProtection'
import PageHeader from '@/components/parts/PageHeader'

import { mapGetters } from 'vuex'

export default {
	name: 'single-page',
	components: {
		PageHeader,
		ModuleBuilder,
		PasswordProtection,
		SocialShareArticle,
	},
	computed: {
		...mapGetters(['currentPageID', 'currentPage', 'currentPostType']),
		isProtected() {
			let isProtected = false
			if (this.currentPage && this.currentPage.is_protected === true) {
				isProtected = true
			}
			return isProtected
		},
	},
}
</script>
